export default "__VITE_ASSET__CY$8u7Y2__"